import React from 'react'
import PropTypes from 'prop-types'
import Link from '../Link/index'

const MyLibraryNavItem = (props) => {
  const {
    url,
    text,
    icon,
    location,
    onClick,
  } = props

  const textClassName = [
    'my-library__nav-item-text',
    location.pathname === url ? 'my-library__nav-item-text--selected' : null,
  ].filter((cls) => cls).join(' ')

  return (
    <li className="my-library__nav-item">
      <Link
        to={url}
        onClick={onClick}
        className="my-library__nav-item-link"
      >
        {icon || null }
        <span className={textClassName}>
          {text}
        </span>
      </Link>
    </li>
  )
}

MyLibraryNavItem.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.element,
  location: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default MyLibraryNavItem
